import {Component, forwardRef, Injector, Input} from "@angular/core";
import {AbstractEditControlComponent} from "../../../entity/edit/edit-controls/abstract-edit-control.component";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PasswordEditControlComponent),
    multi: true
};

@Component({
    providers: [CUSTOM_VALUE_ACCESSOR],
    selector: "wbo-password-edit-control",
    templateUrl: "./password-edit-control.component.html",
})
export class PasswordEditControlComponent extends AbstractEditControlComponent {
    @Input() public notation: string;
    @Input() allowAutocomplete: boolean;

    constructor(injector: Injector) {
        super(injector);
    }
}
